// Daily study reminder (local notifications, app only).
// Every finished lesson reschedules the next three days from scratch, so a day already studied never gets a nudge.
import { LocalNotifications } from '@capacitor/local-notifications';
import { isNative } from '../utils/native';

const KEY = 'reminder'; // "H:M" once the user opted in
const IDS = [1, 2, 3];
const MESSAGES = [
  (due) => ({ title: '오늘의 레슨 6분 🔥', body: due > 0 ? `잊기 직전 단어 ${due}개가 기다려요.` : '새 단어 10개가 기다려요.' }),
  () => ({ title: '두벅이가 기다려요', body: '오늘 6분만 공부하고 연속 기록을 다시 이어 가요.' }),
  () => ({ title: '아직 늦지 않았어요', body: '복습할 단어가 쌓이고 있어요. 6분이면 충분해요.' }),
];

const saved = () => {
  try { return localStorage.getItem(KEY); } catch (e) { return null; }
};
export const reminderOn = () => isNative && !!saved();

async function schedule(hm, due) {
  const [h, m] = hm.split(':').map(Number);
  await LocalNotifications.cancel({ notifications: IDS.map(id => ({ id })) });
  await LocalNotifications.schedule({
    notifications: IDS.map((id, i) => {
      const at = new Date();
      at.setDate(at.getDate() + 1 + i);
      at.setHours(h, m, 0, 0);
      return { id, ...MESSAGES[i](due), schedule: { at }, isExactNotification: false };
    }),
  });
}

// Opt in at "this time tomorrow"; false when the user denies notifications
export async function enableReminder(due) {
  const { display } = await LocalNotifications.requestPermissions();
  if (display !== 'granted') return false;
  const now = new Date();
  const hm = `${now.getHours()}:${now.getMinutes()}`;
  localStorage.setItem(KEY, hm);
  await schedule(hm, due);
  return true;
}

// After every finished lesson
export function refreshReminder(due) {
  const hm = isNative && saved();
  if (hm) schedule(hm, due).catch(() => { });
}
